import React from 'react';
import Footer from '../components/Footer';
import vision from '../Team/vision.jpg';
import mission from '../Team/mission.jpg';

const About = () => {
  return (
    <>
      <div className="container my-5">
        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-body p-4 p-md-5">

            {/* About Us Section */}
            <h2 className="text-center mb-4 fw-bold text-primary">About Agency Bazaar</h2>
            
            <p style={{ textAlign: 'justify', lineHeight: '1.7' }}>
              <strong>Agency Bazaar</strong> is India's leading recruitment and career development platform in the insurance sector, dedicated to creating a financial revolution by empowering every individual to build a rewarding career in insurance. With a strong foundation built on industry expertise and practical understanding, we specialize in connecting talented individuals with India's top insurance companies including Aditya Birla, Niva Bupa, Care Health, Star Health, Tata AIG, Tata AIA, and Go Digit.
            </p>

            <p style={{ textAlign: 'justify', lineHeight: '1.7' }}>
              In today's scenario, many people avoid careers in the insurance sector due to lack of awareness, misconceptions about sales roles, and uncertainty about income potential. Agency Bazaar aims to change this perception by providing complete guidance, IRDAI-certified training, mentorship from top performers, and access to a single platform with multiple insurers. We help individuals discover the true potential of an insurance career — unlimited income, lifetime renewals, flexible working hours, zero investment, and the ability to be their own boss.
            </p>

            <p style={{ textAlign: 'justify', lineHeight: '1.7' }}>
              With over <strong>5000+ successful agents</strong> in our network — including <strong>40% women agents</strong> and <strong>1500+ retired officers</strong> — we have proven that insurance careers offer financial independence, dignity, and growth. Our top agents consistently earn <strong>₹2 lakhs+ per month</strong> through commissions, bonuses, and lifetime renewal income.
            </p>

            <p style={{ textAlign: 'justify', lineHeight: '1.7' }}>
              We believe that by strengthening careers in insurance, we also contribute to building a more financially aware and secure society. As IRDAI pushes for <strong>"Insurance for All by 2047"</strong> and with India's insurance penetration at just <strong>4.2% versus the global average of 7%</strong>, the opportunity for growth is unlimited.
            </p>

            {/* Vision & Mission Section */}
            <div className="row mt-5 g-4">

              {/* Vision */}
              <div className="col-md-6">
                <div className="p-4 h-100 shadow-sm rounded-4 bg-light">
                  <h4 className="fw-bold text-success text-center mb-3">Our Vision</h4>
                  <center>
                    <img 
                      src={vision} 
                      style={{ borderRadius: '16px', maxWidth: '100%', height: 'auto', marginBottom: '1rem' }} 
                      alt="Vision" 
                    />
                  </center>
                  <p style={{ textAlign: 'justify', lineHeight: '1.7' }}>
                    Our vision is to drive a <strong>financial revolution across India</strong> by making insurance careers accessible, respected, and rewarding for every individual — from fresh graduates and homemakers to retired professionals seeking meaningful second careers.
                  </p>
                  <p style={{ textAlign: 'justify', lineHeight: '1.7' }}>
                    We aspire to become <strong>India's most trusted platform for insurance recruitment and career development</strong>, serving over 50,000 active agents by 2030. Through continuous innovation, ethical practices, and a one-platform-multiple-insurers model, we aim to bridge the gap between talented individuals and India's leading insurance companies.
                  </p>
                  <p style={{ textAlign: 'justify', lineHeight: '1.7' }}>
                    We envision a future where insurance careers are seen as <strong>prestigious, fulfilling, and primary career choices</strong>, attracting the best talent from across the nation. By empowering 1 million families with financial security through our agents, we will contribute to a financially aware, protected, and prosperous India.
                  </p>
                </div>
              </div>

              {/* Mission */}
              <div className="col-md-6">
                <div className="p-4 h-100 shadow-sm rounded-4 bg-light">
                  <h4 className="fw-bold text-danger mb-3 text-center">Our Mission</h4>
                  <center>
                    <img 
                      src={mission} 
                      style={{ borderRadius: '16px', maxWidth: '100%', height: 'auto', marginBottom: '1rem' }} 
                      alt="Mission" 
                    />
                  </center>
                  <p style={{ textAlign: 'justify', lineHeight: '1.7' }}>
                    <strong>Our mission is to transform the insurance career landscape</strong> by spreading awareness, removing misconceptions, and providing the right guidance, training, and mentorship to aspiring professionals across India.
                  </p>
                  <p style={{ textAlign: 'justify', lineHeight: '1.7' }}>
                    ✅ <strong>Empower 10,000+ new agents annually</strong> with free IRDAI-certified training and certification.<br />
                    ✅ <strong>Provide a single platform</strong> with 7+ top insurers — no captive agent limitations.<br />
                    ✅ <strong>Enable lifetime renewal income</strong> so agents build passive wealth year after year.<br />
                    ✅ <strong>Create flexible career opportunities</strong> for women professionals, homemakers, career breakers, and retired officers.<br />
                    ✅ <strong>Build a supportive community</strong> of 5000+ successful agents for peer learning and mentorship.
                  </p>
                  <p style={{ textAlign: 'justify', lineHeight: '1.7' }}>
                    Through comprehensive training, continuous mentorship, and a zero-investment business model, we strive to create a strong network of skilled insurance advisors who contribute to financial security for themselves, their families, and society at large.
                  </p>
                </div>
              </div>

            </div>

            {/* Key Statistics Section */}
            <div className="row mt-5 g-3 text-center">
              <h4 className="fw-bold text-primary mb-3">Our Impact at a Glance</h4>
              <div className="col-md-3 col-6">
                <div className="p-3 bg-primary bg-opacity-10 rounded-4">
                  <h3 className="fw-bold text-primary mb-0">5000+</h3>
                  <p className="mb-0 text-secondary">Successful Agents</p>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="p-3 bg-success bg-opacity-10 rounded-4">
                  <h3 className="fw-bold text-success mb-0">40%</h3>
                  <p className="mb-0 text-secondary">Women Agents</p>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="p-3 bg-info bg-opacity-10 rounded-4">
                  <h3 className="fw-bold text-info mb-0">1500+</h3>
                  <p className="mb-0 text-secondary">Retired Officers</p>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="p-3 bg-warning bg-opacity-10 rounded-4">
                  <h3 className="fw-bold text-warning mb-0">₹2L+</h3>
                  <p className="mb-0 text-secondary">Avg. Monthly Income</p>
                </div>
              </div>
            </div>

            {/* Why Choose Us Section */}
            <div className="mt-5 pt-3">
              <h4 className="fw-bold text-primary text-center mb-4">Why Join Agency Bazaar?</h4>
              <div className="row g-3">
                <div className="col-md-4">
                  <div className="d-flex gap-3 p-3 bg-light rounded-3">
                    <i className="fas fa-building fs-3 text-primary"></i>
                    <div>
                      <h6 className="fw-bold mb-1">10+ Top Insurers</h6>
                      <small className="text-secondary">Sell from Niva Bupa, Care Health, Star, Tata AIG & more on one platform</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex gap-3 p-3 bg-light rounded-3">
                    <i className="fas fa-sync-alt fs-3 text-success"></i>
                    <div>
                      <h6 className="fw-bold mb-1">Lifetime Renewals</h6>
                      <small className="text-secondary">Earn passive income year after year on every policy sold</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex gap-3 p-3 bg-light rounded-3">
                    <i className="fas fa-chalkboard-user fs-3 text-info"></i>
                    <div>
                      <h6 className="fw-bold mb-1">Free Training & Certification</h6>
                      <small className="text-secondary">Complete IRDAI training provided, no prior experience needed</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </>
  ); 
};

export default About;


